import { graphql, useMutation } from "react-relay";
import { useCallback } from "react";
import { usePersistedEmployeeId } from "@/src/OS/Login/usePersistedEmployeeId";
import { useTodoUploadImageLinkMutation } from "./__generated__/useTodoUploadImageLinkMutation.graphql";

export function useTodoUploadImageLink(todoId: string) {
  const { currentEmployeeId } = usePersistedEmployeeId();
  const [generateUploadLink, isLoadingImageLink] =
    useMutation<useTodoUploadImageLinkMutation>(graphql`
      mutation useTodoUploadImageLinkMutation($todoId: ID!, $employeeId: ID) {
        todo(todoId: $todoId, employeeId: $employeeId) {
          addImage {
            image {
              id
            }
            imageUploadUrl
            todo {
              images {
                id
              }
              ...TodoEditNewMainMediaComponentMedia_todo
            }
          }
        }
      }
    `);

  const prepareUploadLink = useCallback(() => {
    return new Promise<{
      imageId: string;
      uploadURL: string;
    }>((resolve, reject) =>
      generateUploadLink({
        variables: {
          todoId: todoId,
          employeeId: currentEmployeeId,
        },
        onCompleted: (data) => {
          if (data.todo?.addImage?.image.id) {
            resolve({
              imageId: data.todo.addImage.image.id,
              uploadURL: data.todo.addImage.imageUploadUrl,
            });
          } else {
            reject(new Error("No image ID found"));
          }
        },
        onError: (error) => {
          reject(error);
        },
      })
    );
  }, [currentEmployeeId, generateUploadLink, todoId]);
  return [prepareUploadLink, isLoadingImageLink] as const;
}
